import { useTranslation } from "react-i18next";
import { Exit3Icon } from "@/shared/icons";
import { Button } from "@/shared/ui";

type Props = {
  onClick: () => void;
};

export default function FactionExitButton({ onClick }: Props) {
  const { t } = useTranslation("faction");

  return (
    <Button
      variant="solid"
      className="gap-2 h-11 text-[#FF3F3F] bg-[#C01818]/18 hover:bg-[#C01818]/25"
      onClick={onClick}
    >
      <Exit3Icon className="size-4.5 text-[#FF3F3F]" />
      {t("faction.exitFromFaction")}
    </Button>
  );
}
